import React from 'react'
import { Table } from '@ztechapps/webui.data-tools'
import { ListHeader } from './ListHeader'
import { ListRow } from './ListRow'
import { useCheckoutContext } from '../../../index'

export const OrderItemsPreview = () => {
  const context = useCheckoutContext()
  const { document } = context.orderDocumentResult

  return (
    <div className={'col-md-12 mt-2'}>
      <Table dataArray={document?.items} head={<ListHeader />} row={ListRow} />
    </div>
  )
}
